import { Bundle } from '@ali/visualengine';
import style from '@ali/vu-style-property';
import { componentNameForCdnComponent } from "../../const";
import { getContextSetter, getDepsSetter, getJsonPropsSetter } from "../../utils";
import Icon from "./logo";
export default Bundle.createPrototype({
  enableCopy: true,
  title: '嵌入源码组件片段',
  componentName: componentNameForCdnComponent,
  category: '高级',
  icon: Icon,
  screenshot: '',
  docUrl: '',
  configure: [getContextSetter(), {
    name: 'urls',
    title: 'cdn 资源',
    display: 'block',
    // supportVariable: true,
    setter: {
      componentName: 'ArraySetter',
      props: {
        itemSetter: {
          componentName: 'ObjectSetter',
          props: {
            config: {
              items: [{
                name: 'type',
                description: 'type',
                isRequired: true,
                setter: {
                  componentName: 'SelectSetter',
                  props: {
                    options: [{
                      title: 'js',
                      value: 'script'
                    }, {
                      title: 'css',
                      value: 'style'
                    }
                    // { title: 'font', value: 'font' },
                    ]
                  }
                }
              }, {
                name: 'url',
                description: 'url',
                isRequired: true,
                setter: 'StringSetter'
              }]
            }
          }
        }
      }
    }
  }, {
    name: 'componentPath',
    title: '组件路径',
    tip: '组件访问路径, 例如 CNUI.CnRating',
    display: 'block',
    supportVariable: true,
    setter: 'StringSetter'
  }, getJsonPropsSetter(), getDepsSetter()]
});